import React from "react";

const ListingTable2 = () => {
  const plansData = [
    {
      plan: "Gold",
      duration: "2 Months",
      progress: 30,
      risk: "Low",
      category: "Retail",
    },
    {
      plan: "Silver",
      duration: "1 Month",
      progress: 60,
      risk: "Medium",
      category: "Wholesale",
    },
    {
      plan: "Platinum",
      duration: "6 Months",
      progress: 85,
      risk: "High",
      category: "Enterprise",
    },
    {
      plan: "Bronze",
      duration: "15 Days",
      progress: 10,
      risk: "Low",
      category: "Startup",
    },
    {
      plan: "Diamond",
      duration: "12 Months",
      progress: 95,
      risk: "High",
      category: "Corporate",
    },
    {
      plan: "Starter",
      duration: "3 Months",
      progress: 45,
      risk: "Medium",
      category: "SMB",
    },
    {
      plan: "Premium",
      duration: "9 Months",
      progress: 70,
      risk: "Medium",
      category: "Agency",
    },
  ];

  const getProgressColor = (risk) => {
    switch (risk.toLowerCase()) {
      case "low":
        return "bg-success-main";
      case "medium":
        return "bg-warning-main";
      case "high":
      case "very high":
        return "bg-red";
      default:
        return "bg-info-main";
    }
  };

  const getRiskClass = (risk) => {
    switch (risk.toLowerCase()) {
      case "low":
        return "bg-success-focus text-success-main";
      case "medium":
        return "bg-warning-focus text-warning-main";
      case "high":
        return "bg-danger-focus text-danger-main";
      default:
        return "bg-secondary text-dark";
    }
  };

  return (
    <div className="table-responsive scroll-sm">
      <table className="table sm-table bordered-table mb-0">
        <thead>
          <tr>
            <th scope="col" className="text-sm">
              Keyword
            </th>
            <th scope="col" className="text-sm">
              Avg Rank
            </th>
            <th scope="col">
              <div className="max-w-112 mx-auto text-sm">
                <span style={{ whiteSpace: "nowrap" }}>Completion Score</span>
              </div>
            </th>
            <th scope="col" className="text-sm">
              Intent
            </th>
            <th scope="col" className="text-sm">
              Monthly Volume
            </th>
            <th scope="col" className="text-sm">
              Change
            </th>
            <th scope="col" className="text-sm">
              Importance
            </th>
            <th scope="col" className="text-sm">
              Trend
            </th>
          </tr>
        </thead>
        <tbody>
          {plansData.map((item, index) => (
            <tr key={index}>
              <td>{item.plan}</td>
              <td>{item.duration}</td>
              <td>
                <div className="max-w-112 mx-auto d-flex align-items-center gap-1">
                  <div className="w-100" style={{ height: "fit-content" }}>
                    <div
                      className="progress progress-sm rounded-pill"
                      role="progressbar"
                      aria-label="Progress"
                      aria-valuenow={item.progress}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    >
                      <div
                        className={`progress-bar ${getProgressColor(
                          item.risk
                        )} rounded-pill`}
                        style={{ width: `${item.progress}%` }}
                      />
                    </div>
                  </div>
                  <span className="text-secondary-light text-xs fw-medium">
                    {item.progress}%
                  </span>
                </div>
              </td>
              <td>
                <span
                  className={`${getRiskClass(
                    item.risk
                  )} px-24 py-4 rounded-pill fw-medium text-xs`}
                >
                  {item.risk}
                </span>
              </td>
              <td>{item.category}</td>
              <td className="text-primary" style={{ cursor: "pointer" }}>
                View Details
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ListingTable2;
